<template lang="pug">
.cp-dmp
    .page1
      .wrap.procuct-header
        .left-wrap
          p “三峡“数据管理平台
          p 应对企业多品牌、多系统、多权限的复杂业务场景，三峡数据管理平台基于全域全渠道业务过程数据，链接业务人员和IT人员，将数据资产价值形成有形业务策略，助力企业使用全域数据驱动业务爆发式增长
      product-list1(type="dmp")
    content-list(:list="list")
    apply-list(:info="applyInfo", :img="applyImg", :logoList="logoList", @showModal="showModal")
    page-belt(:beltType="1" @showModal="showModal")
</template>
<script>
import productList1 from './components/product-list1'
import contentList from './components/content-list'
import applyList from './components/apply-list'

export default {
  components: {
    productList1,
    contentList,
    applyList,
  },
  props: {},
  data () {
    return {
      list: [
        { title: '数据输入', content: '数据集即开即用，支持多种数据源接入', labels: ['多源兼容', '开箱即用', '高效融合'], imgSrc: require('@/assets/dmp2.png') },
        { title: '数据治理', content: '基于业务结构化字段的标签矩阵', labels: ['数据对称', '自动绿化', '特征工程'], imgSrc: require('@/assets/dmp3.png') },
        { title: '数据清洗', content: '基于业务视图快速构建数据分片与视图层', labels: ['跨表迁移', '特征挖掘', '空错值补全'], imgSrc: require('@/assets/dmp1.png') },
        { title: '策略投放', content: '通过业务预测模型精准拟合，快速定位潜在商机', labels: ['圈选投放', '业务结果拟合', '渠道策略优选'], imgSrc: require('@/assets/dmp4.png') },
      ],
      applyInfo: {
        titles: ['存量用户运营', '策略计划管理', '投放客群回溯'],
        content: '针对存量用户经营过程中的触达模式单一，客群潜在意愿分离困难等问题，“三峡”DMP可高效针对历史业务数据提供新的数据挖掘方向。在对不同特征类型的客群分层后，可匹配转化意愿更强烈的触达媒介和内容模式，做到千人千面，高效转化。'
      },
      applyImg: { src: require('../../assets/dmp5.png'), style: 'width: 348px;margin-bottom: 56px' },
      logoList: [
        { src: require('../../assets/apply-zhongan.png'), style: 'width: 108px' },
        { src: require('../../assets/apply-zhongxin.png'), style: 'width: 106px' },
        { src: require('../../assets/apply-huanbei.png'), style: 'width: 51px' },
      ]
    }
  },
  computed: {},
  methods: {
    showModal () {
      this.$emit('showModal', true)
    }
  }
}
</script>
<style lang="stylus" scoped>
@import './config'
.cp-dmp
  .page1
    padding-top $topbar-height
    background #0a1e50
    .procuct-header
      height 580px
      background: url("../../assets/dmp-banner.png") center no-repeat
      background-size: cover;
      margin-bottom -121px
      margin-top -94px
    .wrap
      position relative
      .left-wrap
        position absolute
        padding-top 178px
        left 20%
        width 389px
        p
          &:first-child
            font-size 36px
            margin-bottom 15px
          &:nth-child(2)
            font-size 16px
            color #D5DCEC
        .banner-btn
          margin-top 38px
    .banner-wrap
      position relative
</style>
